import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Input, Label, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class DesignerToolbar extends Component {
    state = { exportOpen: false };

    _toggleExport = () => this.setState(s => ({ exportOpen: !s.exportOpen }));

    render() {
        const {
            templateName,
            onNameChange,
            onBack,
            onPreview,
            onSave,
            onSaveClose,
            onExportJson,
            onExportHtml,
            onImportClick,
            aiPanelOpen,
            aiPending,
            aiEnabled,
            onToggleAi,
            intl,
        } = this.props;
        const { exportOpen } = this.state;

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '6px 12px',
                    borderBottom: '1px solid #dee2e6',
                    flexWrap: 'wrap',
                    backgroundColor: '#f8f9fa',
                }}
            >
                {/* Back link */}
                <Button color="link" size="sm" className="p-0 mr-1" onClick={onBack} style={{ whiteSpace: 'nowrap' }}>
                    <i className="fas fa-arrow-left mr-1" />
                    <FormattedMessage id="VoucherTemplateDesigner.Back" />
                </Button>

                <div style={{ width: 1, height: 20, backgroundColor: '#dee2e6', flexShrink: 0 }} />

                {/* Template name */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <Label className="mb-0" style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                        <FormattedMessage id="TemplateDesigner.Toolbar.Name" />
                    </Label>
                    <FormattedMessage id="TemplateDesigner.Toolbar.Name">
                        {placeholder => (
                            <Input
                                type="text"
                                bsSize="sm"
                                value={templateName}
                                placeholder={placeholder}
                                onChange={(e) => onNameChange(e.target.value)}
                                style={{ width: 200 }}
                            />
                        )}
                    </FormattedMessage>
                </div>

                {/* Spacer */}
                <div style={{ flexGrow: 1 }} />

                {/* Load from file */}
                <Button size="sm" color="secondary" onClick={onImportClick}>
                    <i className="fa-solid fa-folder-open mr-1" />
                    <FormattedMessage id="TemplateDesigner.Toolbar.LoadFile" />
                </Button>

                {/* Save to file — split dropdown: JSON / HTML */}
                <ButtonDropdown isOpen={exportOpen} toggle={this._toggleExport}>
                    <DropdownToggle size="sm" color="secondary" caret>
                        <i className="fa-solid fa-file-export mr-1" />
                        <FormattedMessage id="TemplateDesigner.Toolbar.SaveFile" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem onClick={onExportJson}>
                            <i className="fa-solid fa-code mr-2" />
                            JSON
                        </DropdownItem>
                        <DropdownItem onClick={onExportHtml}>
                            <i className="fa-solid fa-file-code mr-2" />
                            <FormattedMessage id="TemplateDesigner.Toolbar.SaveFileHtml" />
                        </DropdownItem>
                    </DropdownMenu>
                </ButtonDropdown>

                <div style={{ width: 1, height: 20, backgroundColor: '#dee2e6', flexShrink: 0 }} />

                {/* Action buttons */}
                <Button size="sm" color="secondary" onClick={onPreview}>
                    <i className="fa-solid fa-eye mr-1" />
                    <FormattedMessage id="TemplateDesigner.Toolbar.Preview" />
                </Button>
                <Button size="sm" className="btn-host" onClick={onSave}>
                    <i className="fa-solid fa-floppy-disk mr-1" />
                    <FormattedMessage id="TemplateDesigner.Toolbar.Save" />
                </Button>
                <Button size="sm" className="btn-host" onClick={onSaveClose}>
                    <i className="fa-solid fa-floppy-disk mr-1" />
                    <FormattedMessage id="TemplateDesigner.Toolbar.SaveClose" />
                </Button>

                {aiEnabled && (
                    <>
                        <div style={{ width: 1, height: 20, backgroundColor: '#dee2e6', flexShrink: 0 }} />

                {/* AI Assistant toggle */}
                        <Button
                            size="sm"
                            color={aiPanelOpen ? 'host' : 'secondary'}
                            className={aiPanelOpen ? 'btn-host' : ''}
                            onClick={onToggleAi}
                            disabled={!!aiPending}
                            aria-expanded={!!aiPanelOpen}
                            aria-controls="ai-assistant-panel"
                            title={intl.formatMessage({ id: 'TemplateDesigner.Toolbar.AiAssistant' })}
                        >
                            <i className="fa-solid fa-robot mr-1" aria-hidden="true" />
                            <FormattedMessage id="TemplateDesigner.Toolbar.AiAssistant" />
                        </Button>
                    </>
                )}
            </div>
        );
    }
}

export default injectIntl(DesignerToolbar);
